import React, { FC, useCallback, useEffect, useMemo, useState } from 'react'

import { SliderContext } from '@Components/Product/Slider/Context/SliderContext'
import { Product } from '@Generated/graphql'

const Slider: FC<{ slides: NonNullable<Product['assets']> }> = ({ children, slides }) => {
  const [activeSlide, setActiveSlide] = useState({ key: 0, recalculate: true })
  const [isFullscreen, setFullscreen] = useState(false)
  const [isSwipedUp, setSwipeUp] = useState(false)

  useEffect(() => {
    const html = (document.getElementsByTagName('BODY') as HTMLCollectionOf<HTMLElement>)[0]
    html.style.overflow = isFullscreen ? 'hidden' : ''
    html.style.position = isFullscreen ? 'fixed' : ''
  }, [isFullscreen])

  const goToNextSlide = useCallback((recalculate: boolean) => {
    setActiveSlide((current) => {
      const next = current.key + 1
      return {
        key: next >= slides.length ? 0 : next,
        recalculate,
      }
    })
  }, [slides])

  const goToPreviousSlide = useCallback(
    (recalculate: boolean) => {
      setActiveSlide((current) => {
        const next = current.key - 1
        if (next < 0) {
          return { key: slides.length - 1, recalculate }
        }
        return { key: next, recalculate }
      })
    },
    [setActiveSlide, slides],
  )

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const toggleFullscreen = () => {
    if (isFullscreen) {
      setActiveSlide({ key: activeSlide.key, recalculate: true })
    }
    setFullscreen(!isFullscreen)
  }
  const isVideoSlide = slides[activeSlide.key]?.tags?.includes('video') || false

  const value = useMemo(
    () => ({
      activeSlide,
      goToNextSlide,
      isVideoSlide,
      isSwipedUp,
      setSwipeUp,
      isFullscreen,
      goToPreviousSlide,
      setActiveSlide,
      toggleFullscreen,
      slides,
    }),
    [
      activeSlide,
      goToNextSlide,
      isVideoSlide,
      isFullscreen,
      toggleFullscreen,
      goToPreviousSlide,
      isSwipedUp,
      slides,
    ],
  )

  return (
    <SliderContext.Provider value={value}>
      {children}
    </SliderContext.Provider>
  )
}

export default Slider
